import React from 'react';
import { Link } from 'react-router-dom';

export const About: React.FC = () => {
  return (
    <div className="pb-20 pt-28">
      <div className="container-width section-padding">
        <p className="eyebrow">About</p>
        <h1 className="max-w-3xl font-display text-4xl sm:text-5xl">SynqTag is a workspace, built in Adelaide.</h1>
        <div className="mt-8 grid gap-10 lg:grid-cols-[minmax(0,1.3fr)_minmax(0,0.7fr)]">
          <div className="space-y-5 text-lg leading-relaxed text-ink-soft">
            <p>
              It holds work items, the pages that go with them, the hours spent, and a portfolio
              across every workspace in the organization. Dimensions are how you classify the work
              when a single tag list is not enough.
            </p>
            <p>
              The app you sign in to is the source for this site. The screenshots are the demo
              organization on 6 October 2026, using the Forest theme. The product default is Warm
              Atelier — terracotta on parchment — and an organization can switch themes.
            </p>
            <p>
              SynqTag is built and maintained by Deesha Tech, an Adelaide software studio. The
              studio’s other work covers business software, routing, and messaging. The product
              itself is this workspace.
            </p>
          </div>
          <aside className="surface-card h-fit p-6">
            <h2 className="font-display text-2xl">Deesha Tech</h2>
            <p className="mt-3 text-sm leading-relaxed text-ink-soft">
              Adelaide. SynqTag is one of the products the studio ships and runs.
            </p>
            <a
              href="https://deesha.tech"
              className="mt-5 inline-flex min-h-11 items-center font-semibold text-forest"
              target="_blank"
              rel="noopener noreferrer"
            >
              deesha.tech
            </a>
          </aside>
        </div>

        <div className="mt-14 grid gap-4 sm:grid-cols-3">
          <article className="surface-card p-5">
            <h2 className="font-display text-xl">What we will say</h2>
            <p className="mt-2 text-sm text-ink-soft">
              How a workspace, a dimension, a budget, and the assistant behave, because that is in the app.
            </p>
          </article>
          <article className="surface-card p-5">
            <h2 className="font-display text-xl">What we will not invent</h2>
            <p className="mt-2 text-sm text-ink-soft">
              Customer counts, uptime percentages, and quotes from companies that are not customers.
            </p>
          </article>
          <article className="surface-card p-5">
            <h2 className="font-display text-xl">Where to write</h2>
            <p className="mt-2 text-sm text-ink-soft">
              <a className="font-semibold text-forest" href="mailto:team@synqtag.com">team@synqtag.com</a>
              {' '}or the <Link className="font-semibold text-forest" to="/contact">contact form</Link>.
            </p>
          </article>
        </div>
      </div>
    </div>
  );
};
